var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 43,
    viewBox: "0 0 26 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.216 28.352C25.216 30.016 24.784 31.584 23.92 33.056C23.088 34.496 21.84 35.696 20.176 36.656C18.544 37.584 16.608 38.128 14.368 38.288V42.176H11.296V38.24C8.096 37.952 5.52 36.992 3.568 35.36C1.616 33.696 0.608 31.456 0.544 28.64H7.744C7.936 30.944 9.12 32.336 11.296 32.816V23.648C8.992 23.072 7.136 22.496 5.728 21.92C4.32 21.344 3.104 20.416 2.08 19.136C1.056 17.856 0.544 16.112 0.544 13.904C0.544 11.12 1.536 8.848 3.52 7.088C5.536 5.328 8.128 4.32 11.296 4.064V0.175998H14.368V4.064C17.44 4.32 19.888 5.248 21.712 6.848C23.568 8.448 24.608 10.656 24.832 13.472H17.584C17.488 12.544 17.152 11.744 16.576 11.072C16.032 10.368 15.296 9.872 14.368 9.584V18.656C16.768 19.264 18.656 19.856 20.032 20.432C21.44 20.976 22.656 21.888 23.68 23.168C24.704 24.416 25.216 26.144 25.216 28.352ZM7.552 13.568C7.552 14.624 7.872 15.488 8.512 16.16C9.152 16.8 10.08 17.328 11.296 17.744V9.44C10.144 9.6 9.232 10.032 8.56 10.736C7.888 11.44 7.552 12.384 7.552 13.568ZM14.368 32.912C15.584 32.688 16.528 32.192 17.2 31.424C17.904 30.656 18.256 29.728 18.256 28.64C18.256 27.584 17.92 26.736 17.248 26.096C16.576 25.456 15.616 24.928 14.368 24.512V32.912Z",
    fill: "#602EF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.9a564c830d4156c5d1471baff8f83d9e.svg";
export { ForwardRef as ReactComponent };